<!--经营风险-->
<template>
  <div class="operate">
    <!--经营异常-->
    <div ref="business0" class="first-content">
      <div class="title-min SourceHanSansCN">经营异常<span class="quota">{{ abnormalOperationBase.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable16" :data="abnormalOperationBase" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="includedTime" title="列入日期" width="120">
            <template #default="{ row }">
              <span v-if="row.includedTime">{{ $moment(row.includedTime).format('YYYY-MM-DD') }}</span>
              <span v-else>-</span>
            </template>
          </vxe-column>
          <vxe-column field="decisionMakingBody" title="作出决定机关"></vxe-column>
          <vxe-column field="includedReason" title="列入经营异常名录原因"></vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--行政处罚-->
    <div ref="business1" class="essential-content">
      <div class="title-min SourceHanSansCN">行政处罚<span class="quota">{{ administrativeSanction.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable17" :data="administrativeSanction" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="punishDecisionDate" title="处罚日期" width="120" align="center"></vxe-column>
          <vxe-column field="decisionBookNumber" title="决定文书号" width="240"></vxe-column>
          <vxe-column field="illegalActsType" title="处罚事由/违法行为类型"></vxe-column>
          <vxe-column field="decisionOffice" title="处罚单位"></vxe-column>
          <vxe-column field="dataSources" title="数据来源"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="administrativePenaltyDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--严重违法-->
    <div ref="business2" class="essential-content">
      <div class="title-min SourceHanSansCN">严重违法<span class="quota">{{ seriousViolation.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable18" :data="seriousViolation" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="includedDecisionOffice" title="列入决定机关"></vxe-column>
          <vxe-column field="reason" title="列入严重违法失信企业名单原因"></vxe-column>
          <vxe-column field="includedTime" title="列入日期" width="120"></vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--股权出质-->
    <div ref="business3" class="essential-content">
      <div class="title-min SourceHanSansCN">股权出质<span class="quota">{{ equityPledge.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable19" :data="equityPledge" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="registrationDate" title="股权出质设立登记日期" width="180"/>
          <vxe-column field="registrationNumber" title="登记编号"/>
          <vxe-column field="investor" title="出质人"/>
          <vxe-column field="enterprise" title="出质股权标的企业"/>
          <vxe-column field="pledgee" title="质权人"/>
          <vxe-column field="amount" title="出质股权数额" width="120">
            <template #default="{ row }">
              <span>{{ row.amount }}万元</span>
            </template>
          </vxe-column>
          <vxe-column field="status" title="状态" width="80">
            <template #default="{ row }">
              <span v-if="row.status==='有效'" style="color: #1FC89F !important;">有效</span>
              <span v-else>无效</span>
            </template>
          </vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="equityPledgeDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--股权质押-->
    <div ref="business4" class="essential-content">
      <div class="title-min SourceHanSansCN">股权质押</div>
      <div class="table-menu">
        <div class="result-left">抵押权人信息</div>
        <div style="margin: 0px 30px;">
          <el-row>
            <el-col :span="4" class="col-8">股票代码</el-col>
            <el-col :span="8" class="col-9">{{ sharePledge.proportion.stockCode || '-' }}</el-col>
            <el-col :span="4" class="col-8">股票简称</el-col>
            <el-col :span="8" class="col-9">{{ sharePledge.proportion.stockName || '-' }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="col-8">质押比例</el-col>
            <el-col :span="8" class="col-9" v-if="sharePledge.proportion.pledgeProportion">
              {{ sharePledge.proportion.pledgeProportion }}%
            </el-col>
            <el-col :span="8" class="col-9" v-else>-</el-col>
            <el-col :span="4" class="col-8">质押股数</el-col>
            <el-col :span="8" class="col-9" v-if="sharePledge.proportion.pledgeNumber">
              {{ sharePledge.proportion.pledgeNumber }}股
            </el-col>
            <el-col :span="8" class="col-9" v-else>-</el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="col-8">质押市值</el-col>
            <el-col :span="8" class="col-9" v-if="sharePledge.proportion.pledgeMarketValue">
              {{ sharePledge.proportion.pledgeMarketValue }}元
            </el-col>
            <el-col :span="8" class="col-9" v-else>-</el-col>
            <el-col :span="4" class="col-8">质押笔数</el-col>
            <el-col :span="8" class="col-9">{{ sharePledge.proportion.pledgeNumberStrokes || '-' }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="col-8">无限售股质押数</el-col>
            <el-col :span="8" class="col-9" v-if="sharePledge.proportion.infinitePledgeAmount">
              {{ sharePledge.proportion.infinitePledgeAmount }}股
            </el-col>
            <el-col :span="8" class="col-9" v-else>-</el-col>
            <el-col :span="4" class="col-8">限售股质押数</el-col>
            <el-col :span="8" class="col-9" v-if="sharePledge.proportion.limitedPledgeAmount">
              {{ sharePledge.proportion.limitedPledgeAmount }}股
            </el-col>
            <el-col :span="8" class="col-9" v-else>-</el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="col-8">近一年涨跌幅</el-col>
            <el-col :span="8" class="col-9" v-if="sharePledge.proportion.upDownRange">
              {{ sharePledge.proportion.upDownRange }}%
            </el-col>
            <el-col :span="8" class="col-9" v-else>-</el-col>
            <el-col :span="4" class="col-8">所属行业</el-col>
            <el-col :span="8" class="col-9">
              <span v-if="sharePledge.proportion.industry">
                {{ sharePledge.proportion.industry }}
              </span>
              <span v-else>-</span>
            </el-col>
          </el-row>
        </div>
        <div class="result-left2">重要股东质押统计（质押中）</div>
        <vxe-table resizable border ref="xTable20" :data="sharePledge.PledgeStatistics" align="center"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号"></vxe-column>
          <vxe-column field="updateTime" title="更新日期" width="120"></vxe-column>
          <vxe-column field="shareholderName" title="股东名称"></vxe-column>
          <vxe-column field="newestNumberPledge" title="近期质押笔数"></vxe-column>
          <vxe-column field="surplusNumberPledge" title="剩余质押股数">
            <template #default="{ row }"><span>{{ row.surplusNumberPledge }}股</span></template>
          </vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link :underline="false" type="primary" @click="pledgeDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
        <div class="result-left2">股东质押明细</div>
        <vxe-table resizable border ref="xTable21" :data="sharePledge.PledgeDetail" align="center"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号"></vxe-column>
          <vxe-column field="announcementDate" title="公告日期" width="120"></vxe-column>
          <vxe-column field="shareholderName" title="股东名称"></vxe-column>
          <vxe-column field="number" title="质押股份数量"></vxe-column>
          <vxe-column field="marketValue" title="质押股份市值"></vxe-column>
          <vxe-column field="status" title="状态"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link :underline="false" type="primary" @click="shareholderDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--税收违法-->
    <div ref="business5" class="essential-content">
      <div class="title-min SourceHanSansCN">税收违法<span class="quota">{{ taxViolationInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable22" :data="taxViolationInfo" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="companyName" title="企业名称"></vxe-column>
          <vxe-column field="caseNature" title="案件性质"></vxe-column>
          <vxe-column field="taxAuthorities" title="所属税务机关"></vxe-column>
          <vxe-column field="releaseTime" title="发布日期" width="120"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="taxViolationsDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--动产抵押-->
    <div ref="business6" class="essential-content">
      <div class="title-min SourceHanSansCN">动产抵押<span class="quota">{{ chattelMortgageTableData.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable23" :data="chattelMortgageTableData" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="registrationNumber" title="登记编号" width="120"></vxe-column>
          <vxe-column field="nameMortgagee" title="抵押权人"></vxe-column>
          <vxe-column field="ownership" title="所有权或使用归属权"></vxe-column>
          <vxe-column field="guaranteedBondType" title="被担保债券类型"></vxe-column>
          <vxe-column field="amountGuaranteedBonds" title="被担保债券数额" width="150"></vxe-column>
          <vxe-column field="termPerformance" title="债务人履行债务的期限"></vxe-column>
          <vxe-column field="registrationAuthority" title="登记机关" width="120"></vxe-column>
          <vxe-column field="dateRegistration" title="登记日期" width="120"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link :underline="false" type="primary" @click="chattelMortgageDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--环保处罚-->
    <div ref="business7" class="essential-content">
      <div class="title-min SourceHanSansCN">环保处罚<span class="quota">{{ environmentalPunishment.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable24" :data="environmentalPunishment" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="decisionBookNumber" title="决定文书号"></vxe-column>
          <vxe-column field="punishmentReasons" title="处罚事由"></vxe-column>
          <vxe-column field="punishmentResult" title="处罚结果"></vxe-column>
          <vxe-column field="punishmentUnit" title="处罚单位"></vxe-column>
          <vxe-column field="implementation" title="执行情况"></vxe-column>
          <vxe-column field="punishmentDate" title="处罚日期" width="120"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="environmentalPenaltiesDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--欠税公告-->
    <div ref="business8" class="essential-content">
      <div class="title-min SourceHanSansCN">欠税公告<span class="quota">{{ arrearsNotice.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable25" :data="arrearsNotice" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="releaseTime" title="发布日期" width="120"></vxe-column>
          <vxe-column field="identificationNumber" title="纳税人识别号"></vxe-column>
          <vxe-column field="taxCategory" title="欠税税种"></vxe-column>
          <vxe-column field="newTaxArrearsBalance" title="当前新发生的欠税余额"></vxe-column>
          <vxe-column field="taxArrearsBalance" title="欠税余额"></vxe-column>
          <vxe-column field="taxAuthorities" title="税务机关"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="taxArrearsAnnouncementDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--清算信息-->
    <div ref="business9" class="essential-content">
      <div class="title-min SourceHanSansCN">清算信息<span class="quota">{{ clearInfo.length }}</span></div>
      <div class="table-menu" v-if="clearInfo.length>0">
        <el-row v-for="clear in clearInfo" style="margin: 0px 30px;">
          <el-col :span="4" class="col-8">清算组负责人：</el-col>
          <el-col :span="8" class="col-9">{{ clear.personCharge ? clear.personCharge : '-' }}</el-col>
          <el-col :span="4" class="col-8">清算组成员：</el-col>
          <el-col :span="8" class="col-9">{{ clear.member ? clear.member : '-' }}</el-col>
        </el-row>
      </div>
      <div class="table-menu" v-else>
        <el-empty description="暂无清算信息"/>
      </div>
    </div>
    <!--知识产权出质-->
    <div ref="business10" class="essential-content">
      <div class="title-min SourceHanSansCN">知识产权出质<span class="quota">{{ intellectualProperty.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable26" :data="intellectualProperty" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="patentType" title="出质知产类型">
            <template #default="{ row }">
              <span v-if="row.patentType==1">专利</span>
              <span v-else-if="row.patentType==2">软件著作权</span>
              <span v-else-if="row.patentType==3">作品著作权</span>
              <span v-else-if="row.patentType==4">商标</span>
            </template>
          </vxe-column>
          <vxe-column field="patentName" title="名称"></vxe-column>
          <vxe-column field="pledgeRegistrationNo" title="出质登记号"></vxe-column>
          <vxe-column field="pledgeAnnouncementDate" title="出质公告日" width="120"></vxe-column>
          <vxe-column field="pledgorName" title="出质人名称"></vxe-column>
          <vxe-column field="pledgeeName" title="质权人名称" width="120"></vxe-column>
          <vxe-column field="pledgePeriod" title="出质期限" width="120"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="intellectualPropertyDetails(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--公示催告-->
    <div ref="business11" class="essential-content">
      <div class="title-min SourceHanSansCN">公示催告<span class="quota">{{ publicNoticeTableData.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable27" :data="publicNoticeTableData" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="billNo" title="票据号"/>
          <vxe-column field="applicant" title="申请人"/>
          <vxe-column field="holder" title="持票人"/>
          <vxe-column field="faceValue" title="票面金额" width="160"/>
          <vxe-column field="type" title="票据类型" width="180"/>
          <vxe-column field="announcementDate" title="公告日期" width="120"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="publicNoticeDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--土地抵押-->
    <div ref="business12" class="essential-content">
      <div class="title-min SourceHanSansCN">土地抵押<span class="quota">{{ mortgageLand.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable28" :data="mortgageLand" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="location" title="土地坐落"/>
          <vxe-column field="name" title="抵押人"/>
          <vxe-column field="mortgagee" title="抵押权人"/>
          <vxe-column field="startTime" title="抵押起止日期">
            <template #default="{ row }">
              <span>{{ row.startTime }}--{{ row.endTime }}</span>
            </template>
          </vxe-column>
          <vxe-column field="mortgageArea" title="抵押面积（公顷）"/>
          <vxe-column field="mortgageAmount" title="抵押金额（万元）"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="landMortgageDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--简易注销-->
    <div ref="business13" class="essential-content">
      <div class="title-min SourceHanSansCN">简易注销<span class="quota">{{ simpleCancellation.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable29" :data="simpleCancellation" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="companyName" title="公告名称"/>
          <vxe-column field="announcementPeriod" title="公告开始日期-结束日期"/>
          <vxe-column field="result" title="简易注销结果"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="simpleCancellationDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--行政处罚详情-->
    <el-dialog title="行政处罚详情" :visible.sync="Dialog20" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">决定书文号</td>
          <td class="col-td3">{{ AdministrativeSanctionDetails.decisionBookNumber }}</td>
        </tr>
        <tr>
          <td class="col-td1">违法行为类型</td>
          <td class="col-td3">{{ AdministrativeSanctionDetails.illegalActsType }}</td>
        </tr>
        <tr>
          <td class="col-td1">处罚决定日期</td>
          <td class="col-td3">{{ AdministrativeSanctionDetails.punishDecisionDate }}</td>
        </tr>
        <tr>
          <td class="col-td1">决定机关</td>
          <td class="col-td3">{{ AdministrativeSanctionDetails.decisionOffice }}</td>
        </tr>
        <tr>
          <td class="col-td1">处罚变更</td>
          <td class="col-td3">{{ AdministrativeSanctionDetails.penaltyChange }}</td>
        </tr>
        <tr>
          <td class="col-td1">行政处罚内容</td>
          <td class="col-td3">{{ AdministrativeSanctionDetails.administrationPunishContent }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--股权出质详情-->
    <el-dialog title="股权出质详情" :visible.sync="Dialog19" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">股权出质设立登记日期</td>
          <td class="col-td2">{{ EquityContributionDetails.registrationDate || '-' }}</td>
          <td class="col-td1">登记编号</td>
          <td class="col-td2">{{ EquityContributionDetails.registrationNumber || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">出质股权数额</td>
          <td class="col-td2">
            <span v-if="EquityContributionDetails.amount">{{ EquityContributionDetails.amount }}万元</span>
            <span v-else>-</span>
          </td>
          <td class="col-td1">状态</td>
          <td class="col-td2">{{ EquityContributionDetails.status || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">出质人</td>
          <td class="col-td2">{{ EquityContributionDetails.investor || '-' }}</td>
          <td class="col-td1">出质人证件号码</td>
          <td class="col-td2">{{ EquityContributionDetails.investorIdentificationNumber || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">出质股权标的企业</td>
          <td class="col-td2">{{ EquityContributionDetails.enterprise || '-' }}</td>
          <td class="col-td1">质权人</td>
          <td class="col-td2">{{ EquityContributionDetails.pledgee || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">质权人证件号码</td>
          <td class="col-td2">{{ EquityContributionDetails.pledgeeCertificateNumber || '-' }}</td>
          <td class="col-td1">备注</td>
          <td class="col-td2">{{ EquityContributionDetails.remarks || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--股东质押明细详情-->
    <el-dialog title="股东质押明细详情" :visible.sync="Dialog22" style="z-index: 9999;">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">质押人</td>
          <td class="col-td2">{{ shareholdDetail.pledgeInstitution || '-' }}</td>
          <td class="col-td1">质押人参股企业</td>
          <td class="col-td2">{{ shareholdDetail.pledgorEnterprise || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">质押股份数量</td>
          <td class="col-td2">{{ shareholdDetail.number || '-' }}</td>
          <td class="col-td1">质押股份市值</td>
          <td class="col-td2">{{ shareholdDetail.marketValue || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">占所持股份比例</td>
          <td class="col-td2">{{ shareholdDetail.proportionSharesHeld || '-' }}</td>
          <td class="col-td1">占总股本比例</td>
          <td class="col-td2">{{ shareholdDetail.proportionTotalEquity || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">质押权人</td>
          <td class="col-td2">{{ shareholdDetail.shareholderName || '-' }}</td>
          <td class="col-td1">质押原因</td>
          <td class="col-td2">{{ shareholdDetail.reasonsPledge || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">质押目的</td>
          <td class="col-td2">{{ shareholdDetail.purposeOfPledge || '-' }}</td>
          <td class="col-td1">质押日收盘价</td>
          <td class="col-td2">{{ shareholdDetail.closingPrice || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">预警线（估算）</td>
          <td class="col-td2">{{ shareholdDetail.warningLine || '-' }}</td>
          <td class="col-td1">平仓线（估算）</td>
          <td class="col-td2">{{ shareholdDetail.closingLine || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">质押开始日期</td>
          <td class="col-td2">{{ shareholdDetail.pledgeStartDate || '-' }}</td>
          <td class="col-td1">质押解除日期</td>
          <td class="col-td2">{{ shareholdDetail.pledgeEndDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">状态</td>
          <td class="col-td2">{{ shareholdDetail.status || '-' }}</td>
          <td class="col-td1">公告日期</td>
          <td class="col-td2">{{ shareholdDetail.announcementDate || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--税收违法详情-->
    <el-dialog title="税收违法详情" top="10px" :visible.sync="Dialog16" width="60%" style="z-index: 9999">
      <div :style="'overflow: auto;height:'+dialogHeight+'px;'">
        <div class="small-title" style="padding: 0px 0px 10px;">注册信息</div>
        <table class="dialog-table" style="width:100%">
          <tr>
            <td class="col-td1">纳税人名称</td>
            <td class="col-td2">{{ taxViolationBase.companyName || '-' }}</td>
            <td class="col-td1">纳税人识别号</td>
            <td class="col-td2">{{ taxViolationBase.dutyNumber || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">组织机构代码</td>
            <td class="col-td2">{{ taxViolationBase.organizationCode || '-' }}</td>
            <td class="col-td1">注册地址</td>
            <td class="col-td2">{{ taxViolationBase.address || '-' }}</td>
          </tr>
        </table>
        <div class="small-title">案件信息</div>
        <table class="dialog-table" style="width:100%">
          <tr>
            <td class="col-td1">发布日期</td>
            <td class="col-td2">{{ taxViolationBase.releaseTime || '-' }}</td>
            <td class="col-td1">案件性质</td>
            <td class="col-td2">{{ taxViolationBase.caseNature || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">所属税务机关</td>
            <td class="col-td2" colspan="3">{{ taxViolationBase.taxAuthorities || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">主要违法事实</td>
            <td class="col-td2" colspan="3">{{ taxViolationBase.majorViolationsFact || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">相关法律依据及税务处理处罚情况</td>
            <td class="col-td2" colspan="3">{{ taxViolationBase.punishment || '-' }}</td>
          </tr>
        </table>
        <div class="small-title">相关人员及公司</div>
        <table class="dialog-table" style="width:100%">
          <tr>
            <td class="col-td1">法定代表人或负责人</td>
            <td class="col-td2">{{ taxViolationItems.a || '-' }}</td>
            <td class="col-td1">性别</td>
            <td class="col-td2">-</td>
          </tr>
          <tr>
            <td class="col-td1">证件名称</td>
            <td class="col-td2">-</td>
            <td class="col-td1">证件号码</td>
            <td class="col-td2">-</td>
          </tr>
        </table>
        <table class="dialog-table" style="width:100%;margin-top: 10px">
          <tr>
            <td class="col-td1">负有责任的财务负责人</td>
            <td class="col-td2">{{ taxViolationItems.b || '-' }}</td>
            <td class="col-td1">性别</td>
            <td class="col-td2">-</td>
          </tr>
          <tr>
            <td class="col-td1">证件名称</td>
            <td class="col-td2">-</td>
            <td class="col-td1">证件号码</td>
            <td class="col-td2">-</td>
          </tr>
        </table>
        <table class="dialog-table" style="width:100%;margin-top: 10px">
          <tr>
            <td class="col-td1">负有直接责任的中介机构</td>
            <td class="col-td2" colspan="3">{{ taxViolationItems.c || '-' }}</td>
          </tr>
        </table>
        <table class="dialog-table" style="width: -webkit-fill-available;">
          <tr>
            <td class="col-td1">负有直接责任的中介机构从业人员</td>
            <td class="col-td2">-</td>
            <td class="col-td1">性别</td>
            <td class="col-td2">-</td>
          </tr>
          <tr>
            <td class="col-td1">证件名称</td>
            <td class="col-td2">-</td>
            <td class="col-td1">证件号码</td>
            <td class="col-td2">-</td>
          </tr>
        </table>
      </div>
    </el-dialog>
    <!--动产抵押详情-->
    <el-dialog title="动产抵押详情" top="10px" :visible.sync="Dialog12" width="80%" style="z-index: 9999">
      <div :style="'overflow: auto;height:'+dialogHeight+'px;'">
        <div class="small-title" style="padding: 0px 0px 10px;">动产抵押登记信息</div>
        <table class="dialog-table" style="width:100%">
          <tr>
            <td class="col-td1">登记编号</td>
            <td class="col-td3">{{ ChattelDetail.item1.registrationNumber || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">登记机关</td>
            <td class="col-td3">{{ ChattelDetail.item1.registrationAuthority || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">登记日期</td>
            <td class="col-td3">{{ ChattelDetail.item1.dateRegistration || '-' }}</td>
          </tr>
        </table>
        <div class="small-title">抵押权人信息</div>
        <table class="dialog-table" style="width:100%">
          <tr>
            <td class="col-td1">抵押权人名称</td>
            <td class="col-td3">{{ ChattelDetail.item1.nameMortgagee || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">抵押权人证照类型</td>
            <td class="col-td3">{{ ChattelDetail.item1.mortgageeLicenseType || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">证照号码</td>
            <td class="col-td3">{{ ChattelDetail.item1.certificateMortgageeNumber || '-' }}</td>
          </tr>
        </table>
        <div class="small-title">被担保主债权信息</div>
        <table class="dialog-table" style="width:100%">
          <tr>
            <td class="col-td1">种类</td>
            <td class="col-td3">{{ ChattelDetail.item1.guaranteedBondType || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">数额</td>
            <td class="col-td3">{{ ChattelDetail.item1.amountGuaranteedBonds || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">债务人履行债务期限</td>
            <td class="col-td3">{{ ChattelDetail.item1.termPerformance || '-' }}</td>
          </tr>

          <tr>
            <td class="col-td1">担保的范围</td>
            <td class="col-td3">{{ ChattelDetail.item1.scopeGuarantee || '-' }}</td>
          </tr>
          <tr>
            <td class="col-td1">备注</td>
            <td class="col-td3">{{ ChattelDetail.item1.remarks || '-' }}</td>
          </tr>
        </table>
        <div class="small-title">抵押物信息</div>
        <table class="dialog-table" style="width:100%">
          <tr v-for="chat of ChattelDetail.item1.collateralInformation">
            <td class="col-td1">{{ chat.key }}</td>
            <td class="col-td3">{{ chat.value || '-' }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>
    <!--环保处罚详情-->
    <el-dialog title="环保处罚详情" :visible.sync="Dialog15" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">决定书文号</td>
          <td class="col-td2">{{ EnvironmentalPunishmentDetail.decisionBookNumber || '-' }}</td>
          <td class="col-td1">违反法律</td>
          <td class="col-td2">{{ EnvironmentalPunishmentDetail.breakingLaw || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">处罚依据</td>
          <td class="col-td2" style="width: 85%;">{{ EnvironmentalPunishmentDetail.punishmentBasis || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">处罚结果</td>
          <td class="col-td2" style="width: 85%;">{{ EnvironmentalPunishmentDetail.punishmentResult || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">处罚日期</td>
          <td class="col-td2">{{ EnvironmentalPunishmentDetail.punishmentDate || '-' }}</td>
          <td class="col-td1">处罚单位</td>
          <td class="col-td2">{{ EnvironmentalPunishmentDetail.punishmentUnit || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">执行情况</td>
          <td class="col-td2">{{ EnvironmentalPunishmentDetail.implementation || '-' }}</td>
          <td class="col-td1">处罚事由</td>
          <td class="col-td2">{{ EnvironmentalPunishmentDetail.punishmentReasons || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--欠税公告详情-->
    <el-dialog title="欠税公告详情" :visible.sync="Dialog14" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">纳税人类型</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.identificationType || '-' }}</td>
          <td class="col-td1">纳税人识别号</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.identificationNumber || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">负责人姓名</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.name || '-' }}</td>
          <td class="col-td1">证件号码</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.number || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">欠税税种</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.taxCategory || '-' }}</td>
          <td class="col-td1">欠税金额</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.taxArrearsAmount || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">欠税余额</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.taxArrearsBalance || '-' }}</td>
          <td class="col-td1">当前新发生的欠税余额</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.newTaxArrearsBalance || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">税务机关</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.taxAuthorities || '-' }}</td>
          <td class="col-td1">发布日期</td>
          <td class="col-td2">{{ ArrearsNoticeDetails.releaseTime || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">经营地点</td>
          <td class="col-td2" style="width: 85%;">{{ ArrearsNoticeDetails.address || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--专利详情-->
    <el-dialog title="专利详情" :visible.sync="Dialog34" width="60%" top="10px" lock-scroll style="z-index: 9999">
      <patent_Details :patentDetail="patentDetail"></patent_Details>
    </el-dialog>
    <!--公示催告详情-->
    <el-dialog title="公示催告详情" :visible.sync="Dialog11" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">票据号</td>
          <td class="col-td2">{{ noticeReminderDetail.billNo || '-' }}</td>
          <td class="col-td1">申请人</td>
          <td class="col-td2">{{ noticeReminderDetail.applicant || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">出票人</td>
          <td class="col-td2">{{ noticeReminderDetail.drawer || '-' }}</td>
          <td class="col-td1">持票人</td>
          <td class="col-td2">{{ noticeReminderDetail.holder || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">票据类型</td>
          <td class="col-td2">{{ noticeReminderDetail.type || '-' }}</td>
          <td class="col-td1">票面金额</td>
          <td class="col-td2">{{ noticeReminderDetail.faceValue || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">出票日</td>
          <td class="col-td2">{{ noticeReminderDetail.issueTicketsDay || '-' }}</td>
          <td class="col-td1">到期日</td>
          <td class="col-td2">{{ noticeReminderDetail.dueDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">付款银行</td>
          <td class="col-td2">{{ noticeReminderDetail.payingBank || '-' }}</td>
          <td class="col-td1">类别</td>
          <td class="col-td2">{{ noticeReminderDetail.type || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">公告日期</td>
          <td class="col-td2" style="width: 85%;">{{ noticeReminderDetail.announcementDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">公告内容</td>
          <td class="col-td2" style="width: 85%;">{{ noticeReminderDetail.content || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--土地抵押详情-->
    <el-dialog title="土地抵押详情" :visible.sync="Dialog13" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">宗地标识</td>
          <td class="col-td2">{{ landMortgage.identification || '-' }}</td>
          <td class="col-td1">宗地编号</td>
          <td class="col-td2">{{ landMortgage.number || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">所在行政区</td>
          <td class="col-td2">{{ landMortgage.administrativeRegion || '-' }}</td>
          <td class="col-td1">土地面积(公顷)</td>
          <td class="col-td2">{{ landMortgage.landArea || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">宗地座落</td>
          <td class="col-td2" style="width: 85%;">{{ landMortgage.location || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地他项权利人证号</td>
          <td class="col-td2">{{ landMortgage.certificateNumber || '-' }}</td>
          <td class="col-td1">土地使用权证号</td>
          <td class="col-td2">{{ landMortgage.usufructNumber || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地抵押人名称</td>
          <td class="col-td2">{{ landMortgage.name || '-' }}</td>
          <td class="col-td1">土地抵押人性质</td>
          <td class="col-td2">{{ landMortgage.nature || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地抵押权人</td>
          <td class="col-td2">{{ landMortgage.mortgagee || '-' }}</td>
          <td class="col-td1">抵押土地用途</td>
          <td class="col-td2">{{ landMortgage.purpose || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">抵押土地权属性质与使用权类型</td>
          <td class="col-td2">{{ landMortgage.usufructType || '-' }}</td>
          <td class="col-td1">抵押面积(公顷)</td>
          <td class="col-td2">{{ landMortgage.mortgageArea || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">评估金额</td>
          <td class="col-td2">{{ landMortgage.assessmentAmount || '-' }}</td>
          <td class="col-td1">抵押金额</td>
          <td class="col-td2">{{ landMortgage.mortgageAmount || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地抵押登记起始时间</td>
          <td class="col-td2">{{ landMortgage.startTime || '-' }}</td>
          <td class="col-td1">土地抵押结束时间</td>
          <td class="col-td2">{{ landMortgage.endTime || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--简易注销详情-->
    <el-dialog title="简易注销详情" top="10px" :visible.sync="Dialog17" width="50%" style="z-index: 9999">
      <div v-for="simple in simpleCancellation" class="simple">
        <el-row>
          <el-col :span="4" class="col-7" style="height: 70px;line-height: 30px;">企业名称</el-col>
          <el-col :span="8" class="col-2" style="height: 70px;">{{ simple.companyName || '-' }}</el-col>
          <el-col :span="5" class="col-7" style="height: 70px;">统一社会信用代码/注册号</el-col>
          <el-col :span="7" class="col-2" style="height: 70px;">{{ simple.code || '-' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="col-7">登记机关</el-col>
          <el-col :span="20" class="col-2">{{ simple.registrationAuthority || '-' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="col-7">公告期</el-col>
          <el-col :span="8" class="col-2">{{ simple.announcementPeriod || '-' }}</el-col>
          <el-col :span="5" class="col-7">全体投资人承诺书</el-col>
          <el-col :span="7" class="col-2">
            <el-link type="primary" style="vertical-align: inherit;" @click="Dialog18=true">查看详情</el-link>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="col-7">简易注销结果</el-col>
          <el-col :span="8" class="col-2">{{ simple.result || '-' }}</el-col>
          <el-col :span="5" class="col-7">公告申请日期</el-col>
          <el-col :span="7" class="col-2">{{ simple.approvalApplicationDate || '-' }}</el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog :show-close="false" :visible.sync="Dialog18" :modal="false" top="90px" :lock-scroll="true"
               style="z-index: 9999" ref="Dialog18" width="50%">
      <div style="height: 100%">
        <img :src="DetailInfo" style="width: auto;height: auto;">
      </div>
    </el-dialog>
    <!--重要股东质押详情-->
    <el-dialog title="重要股东质押详情" :visible.sync="Dialog21" style="z-index: 9999;">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">股东名称</td>
          <td class="col-td2">{{ SignificantShareholdersDetails.shareholderName || '-' }}</td>
          <td class="col-td1">最新质押笔数</td>
          <td class="col-td2">{{ SignificantShareholdersDetails.newestNumberPledge || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">剩余质押股数</td>
          <td class="col-td2">{{ SignificantShareholdersDetails.surplusNumberPledge || '-' }}</td>
          <td class="col-td1">剩余质押股数市值</td>
          <td class="col-td2">{{ SignificantShareholdersDetails.surplusMarketValue || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">占所持股份比例</td>
          <td class="col-td2">{{ SignificantShareholdersDetails.proportionSharesHeld || '-' }}</td>
          <td class="col-td1">占总股本比例</td>
          <td class="col-td2">{{ SignificantShareholdersDetails.proportionTotalEquity || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">平仓线区间（预估）</td>
          <td class="col-td2">{{ SignificantShareholdersDetails.closingLineSection || '-' }}</td>
          <td class="col-td1">预警线区间（预估）</td>
          <td class="col-td2">{{ SignificantShareholdersDetails.warningLineInterval || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">更新日期</td>
          <td class="col-td2" style="width: 85%;">{{ SignificantShareholdersDetails.updateTime || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import page from "@/components/page/page";
import patent_Details from '@/views/enterpriseDetails/patentDetails'
import {
  abnormalOperation,
  getDdAdministrativeSanctionBycid,
  getDdAdministrativeSanctionDetailsById,
  seriousIllegal,
  ddEquityContribution,
  getDdEquityContributionDetailsById,
  getEquityPledgeRatioProportion,
  getSignificantShareholdersByCid,
  pledgeDetailsById,
  taxViolation,
  taxViolationDetails,
  getChattelMortgageList,
  getChattelMortgageDetails,
  getDdEnvironmentalPunishmentBycid,
  getDdEnvironmentalPunishmentDetailsByid,
  taxArrearsNoticeDetails,
  taxArrearsNotice,
  getClearInformation,
  getNewPledgeIntellectualPropertyList,
  getNewPledgeIntellectualPropertyById,
  noticeReminder,
  noticeReminderDetails,
  landMortgage,
  landMortgageDetails,
  getNewSimpleCancellation,
  getSignificantShareholdersDetails,
} from '@/api/enterpriseDetailsApi'

Vue.use(VXETable)
export default {
  name: "operateRisks",
  components: {page, patent_Details},
  data() {
    return {
      dialogHeight: '750',
      /*经营异常*/
      abnormalOperationBase: [],
      /*行政处罚*/
      administrativeSanction: [],
      /*严重违法*/
      seriousViolation: [],
      /*股权出质*/
      equityPledge: [],
      /*股权质押*/
      sharePledge: {
        proportion: {
          stockCode: '',
          stockName: '',
          pledgeProportion: '',
          pledgeNumber: '',
          pledgeMarketValue: '',
          pledgeNumberStrokes: '',
          infinitePledgeAmount: '',
          limitedPledgeAmount: '',
          upDownRange: '',
          industry: ''
        },
        PledgeStatistics: [], PledgeDetail: []
      },
      /*税收违法*/
      taxViolationInfo: [],
      /*动产抵押*/
      chattelMortgageTableData: [],
      /*环保处罚*/
      environmentalPunishment: [],
      /*欠税公告*/
      arrearsNotice: [],
      /*清算信息*/
      clearInfo: [
        {personCharge: '', member: ''}
      ],
      /*知识产权出质*/
      intellectualProperty: [],
      /*公示催告*/
      publicNoticeTableData: [],
      /*土地抵押*/
      mortgageLand: [],
      /*简易注销*/
      simpleCancellation: [],
      Dialog17: false,
      Dialog20: false,
      Dialog19: false,
      Dialog22: false,
      Dialog16: false,
      Dialog12: false,
      Dialog15: false,
      Dialog14: false,
      Dialog34: false,
      Dialog11: false,
      Dialog13: false,
      Dialog18: false,
      Dialog21: false,
      /*行政处罚详情*/
      AdministrativeSanctionDetails: {},
      /*股权出质详情*/
      EquityContributionDetails: {},
      /*股东质押明细详情*/
      shareholdDetail: {},
      /*获取税收违法详情*/
      taxViolationItems: {},
      taxViolationBase: {},
      /*动产抵押详情*/
      ChattelDetail: {item1: {}, item2: []},
      /*环保处罚详情*/
      EnvironmentalPunishmentDetail: {},
      /*欠税公告详情*/
      ArrearsNoticeDetails: {},
      /*知识产权出资详情*/
      patentDetail: {},
      /*公示催告详情*/
      noticeReminderDetail: {},
      /*土地抵押详情*/
      landMortgage: {},
      /*简易注销详情*/
      DetailInfo: {},
      /*重要股东质押详情*/
      SignificantShareholdersDetails: {},
    }
  },
  props: {
    corpId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  methods: {
    /*经营异常*/
    getAbnormalOperation() {
      abnormalOperation({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.abnormalOperationBase = res.content.rows;
          /*console.log(res.content);*/
        }
      })
    },
    /*行政处罚*/
    getDdAdministrativeSanction() {
      getDdAdministrativeSanctionBycid({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.administrativeSanction = res.content.projectList.rows;
          /*console.log(res.content);*/
        }
      })
    },
    /*行政处罚详情*/
    administrativePenaltyDetail(row) {
      getDdAdministrativeSanctionDetailsById({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.AdministrativeSanctionDetails = res.content;
          /*console.log(res.content);*/
          this.Dialog20 = true;
        }
      })
    },
    /*严重违法*/
    getSeriousIllegal() {
      seriousIllegal({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.seriousViolation = res.content.rows;
          /*console.log(res.content);*/
        }
      })
    },
    /*股权出质*/
    getddEquityContribution() {
      ddEquityContribution({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.equityPledge = res.content.rows;
          /*console.log(res.content);*/
        }
      })
    },
    /*股权出质详情*/
    equityPledgeDetail(row) {
      getDdEquityContributionDetailsById({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.EquityContributionDetails = res.content;
          /*console.log(res.content);*/
          this.Dialog19 = true;
        }
      })
    },
    /*股权质押-抵押权人信息*/
    getEquityPledgeRatio() {
      getEquityPledgeRatioProportion({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          if (res.content != '' && res.content != null && res.content != undefined) {
            if (res.content.rows !== undefined && res.content.rows.length > 0) {
              this.sharePledge.proportion = res.content.rows[0];
            }
          }
        }
      })
    },
    /*股权质押-重要股东质押统计（质押中）*/
    getSignificantShareholders() {
      getSignificantShareholdersByCid({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.sharePledge.PledgeStatistics = res.content.rows;
        }
      })
    },
    /*股东质押明细详情*/
    shareholderDetail(row) {
      pledgeDetailsById({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.shareholdDetail = res.content;
          /*console.log(res.content);*/
          this.Dialog22 = true;
        }
      })
    },
    /*税收违法*/
    getTaxViolation() {
      taxViolation({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.taxViolationInfo = res.content.rows;
          /*console.log(res.content);*/
        }
      })
    },
    /*获取税收违法详情*/
    taxViolationsDetail(row) {
      taxViolationDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.taxViolationBase = res.content;
          this.taxViolationItems = res.content.personnelCompany1;
          this.Dialog16 = true;
        }
      })
    },
    /*动产抵押*/
    getChattelMortgageListBase() {
      getChattelMortgageList({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.chattelMortgageTableData = res.content.chattelMortgageList.rows;
        }
      })
    },
    /*动产抵押详情*/
    chattelMortgageDetail(row) {
      this.ChattelDetail.item1 = {};
      getChattelMortgageDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          res.content.collateralInformation = JSON.parse(res.content.collateralInformation.replace("\\u005c", ""));
          this.ChattelDetail.item1 = res.content;
          this.Dialog12 = true;
        }
      })
    },
    /*环保处罚*/
    getDdEnvironmentalPunishment() {
      getDdEnvironmentalPunishmentBycid({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.environmentalPunishment = res.content.projectList.rows;
        }
      })
    },
    /*环保处罚详情*/
    environmentalPenaltiesDetail(row) {
      getDdEnvironmentalPunishmentDetailsByid({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.EnvironmentalPunishmentDetail = res.content;
          this.Dialog15 = true;
        }
      })
    },
    /*欠税公告*/
    getTaxArrearsNotice() {
      taxArrearsNotice({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.arrearsNotice = res.content.rows;
        }
      })
    },
    /*欠税公告详情*/
    taxArrearsAnnouncementDetail(row) {
      taxArrearsNoticeDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.ArrearsNoticeDetails = res.content;
          this.Dialog14 = true;
        }
      })
    },
    /*清算信息*/
    getClearInformationBase() {
      this.clearInfo = [];
      getClearInformation({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          if (res.content != '' && res.content != null && res.content != undefined) {
            this.clearInfo.push({personCharge: res.content[0].personCharge, member: res.content[0].member});
          }
        }
      })
    },
    /*知识产权出质*/
    getNewPledgeIntellectualProperty() {
      getNewPledgeIntellectualPropertyList({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.intellectualProperty = res.content.rows;
        }
      })
    },
    /*知识产权出资详情*/
    intellectualPropertyDetails(row) {
      getNewPledgeIntellectualPropertyById({
        intellectualPropertyId: row.intellectualPropertyId,
        patentTypeId: 1,
        request: 'form'
      }).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          if (res.content.details.legalStatus != '' && res.content.details.legalStatus != null && res.content.details.legalStatus != undefined) {
            if (res.content.details.legalStatus.indexOf(';') > -1) {
              let arr1 = res.content.details.legalStatus.split(';');
              let lawStatus = {reverse: false, activities: [], legalIndex: arr1.length, legalStatus: ''};
              arr1.forEach(function (row) {
                let arr2 = row.split(' ');
                lawStatus.activities.push({content: arr2[1], timestamp: arr2[0]});
                lawStatus.legalStatus = arr2[1];
              })
              res.content.details.legalStatus = lawStatus;
            } else {
              let arr = res.content.details.legalStatus.split(' ');
              let lawStatus = {reverse: false, activities: [], legalIndex: 1, legalStatus: arr[1]}
              lawStatus.activities.push({content: arr[1], timestamp: arr[0]})
              res.content.details.legalStatus = lawStatus;
            }
          }
          this.Dialog34 = true;
          this.patentDetail = res.content.details;
        }
      })
    },
    /*公示催告*/
    getNoticeReminder() {
      noticeReminder({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          res.content.rows.forEach(function (row, index) {
            if (row.applicant != '' && row.applicant != null && row.applicant != undefined) {
              row.applicant = JSON.parse(row.applicant.replace("\\u005c", "")).name;
            }
            if (row.holder != '' && row.holder != null && row.holder != undefined) {
              row.holder = JSON.parse(row.holder.replace("\\u005c", "")).name;
            }
          })
          this.publicNoticeTableData = res.content.rows;
        }
      })
    },
    /*公示催告详情*/
    publicNoticeDetail(row) {
      noticeReminderDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          if (res.content.applicant != '' && res.content.applicant != null && res.content.applicant != undefined) {
            res.content.applicant = JSON.parse(res.content.applicant.replace("\\u005c", "")).name;
          }
          if (res.content.holder != '' && res.content.holder != null && res.content.holder != undefined) {
            res.content.holder = JSON.parse(res.content.holder.replace("\\u005c", "")).name;
          }
          if (res.content.drawer != '' && res.content.drawer != null && res.content.drawer != undefined) {
            res.content.drawer = JSON.parse(res.content.drawer.replace("\\u005c", "")).name;
          }
          this.noticeReminderDetail = res.content;
          this.Dialog11 = true;
        }
      })
    },
    /*土地抵押*/
    getLandMortgage() {
      landMortgage({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.mortgageLand = res.content.rows;
        }
      })
    },
    /*土地抵押详情*/
    landMortgageDetail(row) {
      landMortgageDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          this.landMortgage = res.content;
          this.Dialog13 = true;
        }
      })
    },
    /*简易注销*/
    getNewSimpleCancellationBase() {
      this.simpleCancellation = [];
      getNewSimpleCancellation({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          /*console.log(res.content);*/
          if (res.content != null && res.content != undefined && res.content != '') {
            this.simpleCancellation.push(res.content);
            this.DetailInfo = res.content.letterCcommitment;
          }
        }
      })
    },
    /*简易注销详情*/
    simpleCancellationDetail(row) {
      this.Dialog17 = true;
    },
    /*重要股东质押详情*/
    pledgeDetail(row) {
      getSignificantShareholdersDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.SignificantShareholdersDetails = res.content;
          this.Dialog21 = true;
        }
      })
    },
    /*定位到指定位置*/
    scrollToArea(ref) {
      window.scrollTo(0, this.$refs[ref].offsetTop - 200);
    },
  },
  mounted() {
    this.getAbnormalOperation();
    this.getDdAdministrativeSanction();
    this.getSeriousIllegal();
    this.getddEquityContribution();
    this.getEquityPledgeRatio();
    this.getSignificantShareholders();
    this.getTaxViolation();
    this.getChattelMortgageListBase();
    this.getDdEnvironmentalPunishment();
    this.getTaxArrearsNotice();
    this.getClearInformationBase();
    this.getNewPledgeIntellectualProperty();
    this.getNoticeReminder();
    this.getLandMortgage();
    this.getNewSimpleCancellationBase();
    this.dialogHeight = document.documentElement.clientHeight - 130;
  }
}
</script>
<style scoped>
.operate >>> .el-dialog__wrapper .el-dialog .el-dialog__body {
  padding: 10px 20px 20px;
  color: #333333;
}
</style>
<style lang="scss" scoped>
.operate {
  .first-content {
    background: white;
  }

  .essential-content {
    background: white;
    margin-top: 10px;
    padding-bottom: 20px;

    .span-red {
      color: #FE273B;
      font-weight: bold
    }

    .el-row-lightblue {
      background: #F1F7FC;
      padding: 30px 0px;
      text-align: center;
      margin: 0px 30px 10px;
    }

    .result-left {
      margin-bottom: 15px;
      color: #222222;
      font-size: 16px;
      padding: 0px 30px;
    }

    .result-left2 {
      margin-bottom: 15px;
      margin-top: 30px;
      color: #222222;
      font-size: 16px;
      padding: 0px 30px;
    }

    .col-8 {
      text-align: left;
      background: #F3F9FC;
      border: 0.5pt solid #e5eef6;
      padding: 15px 0 15px 20px;
    }

    .col-9 {
      text-align: left;
      background: #ffffff;
      border: 0.5pt solid #e5eef6;
      padding: 15px 0 15px 20px;
    }
  }

  .quota {
    padding-left: 10px;
    color: #2B79FE;
  }

  .title-min {
    padding: 20px 30px;
    font-size: 16px;
    font-weight: bold;
    color: #222222;
  }

  .legal {
    width: 50px;
    line-height: revert;
    font-size: 15px;
    color: #333333;
  }

  .el-avatar {
    background: white;
    border: 1px solid #CAD1DA;
    border-radius: 6px;
    height: 50px;
    width: 50px;
    line-height: 48px;
    float: left;
  }

  .small-title {
    font-size: 16px;
    color: #333333;
    text-align: left;
    padding: 30px 0px 10px;
    font-weight: 500;
  }

  .dialog-table {
    table-layout: fixed;
    border-collapse: separate;
    box-sizing: border-box;
    text-indent: initial;
    border-spacing: 0px;
    border-color: grey;

    tr {
      border-spacing: 0px;
    }

    .col-td1 {
      border-spacing: 0px;
      border: 0.03125rem solid #E5EEF6;
      padding: 15px 10px 15px 20px;
      background: #D6E9FF;
      text-align: left;
      color: #333333;
      width: 150px;
    }

    .col-td2 {
      padding: 15px 10px;
      background: #ffffff;
      text-align: left;
      max-width: 35%;
      border-spacing: 0px;
      border: 0.03125rem solid #E5EEF6;
    }

    .col-td3 {
      padding: 15px 10px;
      background: #ffffff;
      text-align: left;
      width: auto;
      border-spacing: 0px;
      word-wrap: break-word;
      border: 0.03125rem solid #E5EEF6;
    }
  }

  .el-dialog__wrapper {
    z-index: 9999 !important;
  }

  .simple {
    .col-7 {
      padding: 15px 10px 15px 20px;
      background: #D6E9FF;
      border: 0.03125rem solid #E5EEF6;
      text-align: left;
      color: #333333;
    }

    .col-2 {
      padding: 15px 10px;
      background: #ffffff;
      border: 0.03125rem solid #E5EEF6;
      text-align: left;
    }
  }

  .table-menu {
    padding: 0px 0px 20px;
  }

  .table-x-table {
    margin: 0px 30px;
    border: 0.5pt solid #e5eef6;
  }
}
</style>